import {
  SentShareGoalInvitesQuery,
  SentShareGoalInvitesQueryVariables,
  UseSentShareGoalInvitesProps,
} from "@ctypes";
import { SENT_SHARE_GOAL_INVITES } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useSentShareGoalInvites = ({ goalId }: UseSentShareGoalInvitesProps) => {
  const { data: queryData, ...rest } = useQuery<
    SentShareGoalInvitesQuery,
    SentShareGoalInvitesQueryVariables
  >(SENT_SHARE_GOAL_INVITES, { variables: { goalId } });

  const data = queryData?.sentShareGoalInvites;

  return { data, ...rest };
};
